import { Context, createContext, useContext } from 'react';

export type Configuration = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: Config | any;
};

export type Config = Configuration | null;

export const AppConfigContext: Context<Config> = createContext<Config>(null);

export default function useAppConfig() {
  return useContext(AppConfigContext);
}
